import { render, staticRenderFns } from "./UsersCreate.vue?vue&type=template&id=8c274d60&scoped=true&"
import script from "./UsersCreate.vue?vue&type=script&lang=js&"
export * from "./UsersCreate.vue?vue&type=script&lang=js&"
import style0 from "./UsersCreate.vue?vue&type=style&index=0&id=8c274d60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c274d60",
  null
  
)

export default component.exports